import { useContext } from 'react';
import { AccountContext } from '@/app/common/context/AccountContext.tsx';

export function useAccount() {
  return useContext(AccountContext);
}
